"use strict";

// Fly-to-cart animation for product-card add buttons (IKEA doors, panels and
// any other quick-add card) and for the custom door "Add this door to your
// bag" CTA. Honours prefers-reduced-motion.
(function () {
  const ADD_BUTTON_SELECTOR =
    ".js-ikea-add-button, product-form .quick-add__submit, .door-builder-add-to-bag";
  const CART_ICON_SELECTOR = "#cart-icon-bubble";
  const FLIGHT_DURATION = 750;
  const ARC_LIFT = 90;
  const SIZE_SCALE = 0.8; // flying image is 80% of the source image size
  // Used when the flight has to start from the button instead of the image
  // (see getOrigin): the image's real size on the page is irrelevant then.
  const BUTTON_ORIGIN_SIZE = 72;
  const BOUNCE_CLASS = "cart-bubble--bounce";

  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function getSourceImage(button) {
    const card = button.closest(".card, .card__inner, .grid__item");
    if (card) {
      return card.querySelector(".card__media img") || card.querySelector("img");
    }

    // Custom doors are configured rather than picked from a product card, so
    // there is no card to fly. Use the finish the shopper chose instead.
    return (
      document.querySelector(
        ".colors-option-section .material__item.selected img",
      ) ||
      document.querySelector(".door_type_grid--item.selected img") ||
      null
    );
  }

  function isInViewport(rect) {
    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth
    );
  }

  // Where the clone starts. Normally the image itself, but the custom-door
  // finish thumbnail lives at the top of the page and is long scrolled away by
  // the time the shopper adds the door — a flight from there is never on
  // screen. Launch from the button that was clicked in that case.
  function getOrigin(sourceImg, button) {
    const imgRect = sourceImg.getBoundingClientRect();
    if (imgRect.width && isInViewport(imgRect)) {
      return {
        rect: imgRect,
        width: imgRect.width * SIZE_SCALE,
        height: imgRect.height * SIZE_SCALE,
      };
    }

    const btnRect = button.getBoundingClientRect();
    if (!btnRect.width) return null;
    return { rect: btnRect, width: BUTTON_ORIGIN_SIZE, height: BUTTON_ORIGIN_SIZE };
  }

  function bounceCartIcon(cartIcon) {
    const bubble = cartIcon.querySelector(".cart-count-bubble") || cartIcon;
    bubble.classList.remove(BOUNCE_CLASS);
    void bubble.offsetWidth; 
    bubble.classList.add(BOUNCE_CLASS);
    bubble.addEventListener(
      "animationend",
      () => bubble.classList.remove(BOUNCE_CLASS),
      { once: true },
    );
  }

  function flyToCart(sourceImg, button, cartIcon) {
    const origin = getOrigin(sourceImg, button);
    const tgtRect = cartIcon.getBoundingClientRect();

    if (!origin || !tgtRect.width) {
      bounceCartIcon(cartIcon);
      return;
    }

    const srcRect = origin.rect;
    const cloneWidth = origin.width;
    const cloneHeight = origin.height;

    const clone = document.createElement("img");
    clone.src = sourceImg.currentSrc || sourceImg.src;
    clone.alt = "";
    clone.className = "fly-to-cart-clone";
    clone.style.left = `${srcRect.left + (srcRect.width - cloneWidth) / 2}px`;
    clone.style.top = `${srcRect.top + (srcRect.height - cloneHeight) / 2}px`;
    clone.style.width = `${cloneWidth}px`;
    clone.style.height = `${cloneHeight}px`;
    document.body.appendChild(clone);

    const dx =
      tgtRect.left + tgtRect.width / 2 - (srcRect.left + srcRect.width / 2);
    const dy =
      tgtRect.top + tgtRect.height / 2 - (srcRect.top + srcRect.height / 2);

    const animation = clone.animate(
      [
        { transform: "translate(0, 0) scale(1)", opacity: 1, offset: 0 },
        {
          transform: `translate(${dx * 0.5}px, ${dy * 0.5 - ARC_LIFT}px) scale(0.6)`,
          opacity: 0.9,
          offset: 0.5,
        },
        {
          transform: `translate(${dx}px, ${dy}px) scale(0.1)`,
          opacity: 0.2,
          offset: 1,
        },
      ],
      {
        duration: FLIGHT_DURATION,
        easing: "cubic-bezier(0.5, 0, 0.75, 1)",
        fill: "forwards",
      },
    );

    animation.onfinish = () => {
      clone.remove();
      bounceCartIcon(cartIcon);
    };
    animation.oncancel = () => clone.remove();
  }

  document.addEventListener("click", (e) => {
    const button = e.target.closest(ADD_BUTTON_SELECTOR);
    if (!button || button.disabled) return;
    // product-form.js marks a card button busy with aria-disabled while its
    // request is in flight.
    if (button.getAttribute("aria-disabled") === "true") return;

    const cartIcon = document.querySelector(CART_ICON_SELECTOR);
    if (!cartIcon) return;

    if (prefersReducedMotion()) return;

    const sourceImg = getSourceImage(button);
    if (!sourceImg) {
      bounceCartIcon(cartIcon);
      return;
    }

    flyToCart(sourceImg, button, cartIcon);
  });
})();
